import * as React from 'react';
import { Component } from "react";
import * as PropTypes from 'prop-types';

const bindCoreUI = (ComponentToWrap: React.ComponentType<any>) => {
    return class UICoreComponent extends Component<any> {

        static contextTypes = {
            uiProvider: PropTypes.object,
        };

        render() {
            const { uiProvider } = this.context;

            return (
                <ComponentToWrap {...this.props} ui={uiProvider} />
            )
        }
    }
};

export default bindCoreUI as any;
